(ns ncr.fragment.ai-assist
  (:require
   [cljs.core.async :refer-macros [go] :refer [<!]]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.etc.pf :as pf]
   [ncr.etc.rhf :as rhf]
   [ncr.fragment.label :as fragment-label]
   [ncr.me :as me]
   [ncr.widgets.pf :as wpf]
   [ncr.widgets.core :as w]
   [ncr.fragment.props.money :as m]
   [ncr.fragment.common :as fc]
   [clojure.string :as str]
   [tick.core :as t]))

(defn c-assist-popover [{:keys [data reference]} & children]
  (let
    [me (uix/context me/*context*)
     all-labels (-> me :cluster :labels)

     {:keys [suggestions]} data

     suggestions (vec (filter #(not (= "IsFinancial" (:Type %))) suggestions))
     is (range (count suggestions))

     defaults
     (into {}
       (for [i is
             :let [{:keys [Decision]} (suggestions i)]]
         [(str i) (= Decision :Set)]))

     form
     (rhf/use-form
       {:shouldFocusError false
        :default-values defaults})

     visible? (uix/state false)
     close
     (fn []
       (reset! visible? false)
       ;; Without setTimeout checkboxes reset to initial value before popover closed.
       (js/setTimeout #((:reset form)) 0))

     selections
     (for [[i v] (js->clj ((:get-values form))) :when v]
       (->> i name parse-long suggestions))

     {label-selections :labels
      title-selections :titles
      other-selections :other}
     (group-by
       (fn [{:keys [Type]}]
         (case Type
           "Label"
           :labels

           "Title"
           :titles

           :other))
       selections)

     submit
     (fn [mode e]
       (.preventDefault e)
       (let [update-title
             (fn []
               (when-some [title (-> title-selections first :Value)]
                 (go (<! (fc/!update-fragment-name reference title)))))

             update-props
             (fn [value-fn reset-non-selected?]
               (let [{:keys [body updated]}
                     (reduce
                       (fn [acc {:keys [Type] :as s}]
                         (let [value (value-fn s)

                               [k v]
                               (case Type
                                 "Brutto" [:common/brutto value]
                                 "Date" [:common/date value]
                                 "Netto" [:common/netto value])]
                           (-> acc
                             (update :body conj Type)
                             (update :updated assoc k v))))
                       {:body [] :updated {}}
                       other-selections)

                     updated
                     (if reset-non-selected?
                       (reduce
                         (fn [acc k]
                           (if (contains? acc k) acc (assoc acc k nil)))
                         updated
                         [:common/brutto :common/date :common/netto])
                       updated)]
                 (when (seq updated)
                   (go (<! (fc/update-props updated (str/join "/" body) reference))))))

             selected-value-fn
             (fn [{:keys [Type Value]}]
               (if (= "Date" Type) (t/date Value) Value))]
         (go
           (let [selected-labels
                 (->> label-selections
                   (map :Value)
                   (map #(str/replace % #"#" ""))
                   (into #{}))

                 labels
                 (->> all-labels
                   (filter #(-> % :name selected-labels))
                   (map :id))]
             (<!
               (fragment-label/!apply-labels [{:id reference}]
                 {:mode mode :labels labels})))

           (case mode
             :add
             (do
               (update-props selected-value-fn false)
               (update-title))

             :set
             (do
               (update-props selected-value-fn true)
               (update-title))

             :remove
             (update-props (constantly nil) false))))
       (close))]
    (into
      [pf/c-popover
       {:class :nrc-ai-assist-popover
        :show-close true
        :has-auto-width true
        :should-close close
        :should-open #(reset! visible? true)
        :position :top
        :enable-flip true
        :on-click u/stop-propagation
        :is-visible @visible?
        :header-content "AI Assist Suggestions"
        :body-content
        (if (seq suggestions)
          [pf/c-form
           [pf/c-data-list {:is-compact true :style {:width "500px"}}
            (for [i is
                  :let [{:keys [Type Value Confidence Currency Decision]}
                        (suggestions i)]
                  :when (not (= "IsFinancial" Type))]
              [pf/c-data-list-item {:key (str i)}
               [pf/c-data-list-item-row
                [pf/c-data-list-item-cells
                 {:width 10
                  :style (when (= Decision :Ignore) {:opacity "50%"})}
                 [pf/c-data-list-cell
                  [wpf/c-pf-checkbox {:name (str i) :form form}]]
                 [pf/c-data-list-cell Confidence "%"]
                 [pf/c-data-list-cell {:width 3} Type]
                 (if (#{"Brutto" "Netto"} Type)
                   [pf/c-data-list-cell {:width 5} (u/format "%s %s" (m/to-string Value) Currency)]
                   [pf/c-data-list-cell {:width 5} (str Value)])]]])]]

          [pf/c-empty-state {:is-full-height false :variant :xs}
           [pf/c-empty-state-icon
            {:variant :container :component
             [w/c-mdi-icon {:icon :emoticon-sad-outline}]}]
           [pf/c-empty-state-body "No AI Suggestions available"]])

        :footer-content
        (when (seq suggestions)
          (let [disabled? (> (count title-selections) 1)]
            [:<>
             [pf/c-button
              {:variant :primary
               :is-disabled disabled?
               :on-click (partial submit :add)}
              "Add"]

             [pf/c-button
              {:variant :secondary
               :is-disabled disabled?
               :on-click (partial submit :remove)}
              "Remove"]

             [pf/c-button
              {:variant :secondary
               :is-disabled disabled?
               :is-danger true
               :on-click (partial submit :set)}
              "Overwrite"]]))}]
      children)))

(defn toolbar-button [attachment]
  (when (-> attachment :data :suggestions)
    [c-assist-popover attachment
     [w/c-toolbar-button
      {:class :pf-u-success-color-100
       :icon :wizard-hat
       :on-click u/stop-propagation
       :tooltip "Show AI Assist"}]]))
